import React from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { Breadcrumb, Col, Row, Space, Tabs } from 'antd';

import SectionTitle from '../../../../components/UI/Panels/SectionTitle/SectionTitle';
import CreateButton from '../../../../components/UI/Buttons/CreateButton/CreateButton';
import RoomFurnishingsTab from './RoomFurnishingsTab/RoomFurnishingsTab';

const TabPane = Tabs.TabPane;

const FrontDeskDetails = () => {
    const history = useHistory();


    const goToAdd = () => {
        history.push('/app/maintenance/frontdesk/add/furnishing');
    }

    return (
        <Row style={{display: 'flex', flexFlow: 'column', height: '100%'}}>
            <Row style={{width: '100%', height: 40, marginBottom: 10}}>
                <Col span={22}>
                    <Row style={{marginLeft: 40, width: '100%', height: 40}}>
                        <Col span={12} style={{display: 'flex', alignItems: 'center'}}>
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    <NavLink to={'/app/maintenance/rooms'}>{'Habitaciones'}</NavLink>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    {'Detalle de hotel'}
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>
                    </Row>
                </Col>
                <Col span={2} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                    <Space>
                        <CreateButton onClick={goToAdd} loading={false} />
                    </Space>
                </Col>
            </Row>

            <SectionTitle title={'Hotel'} />

            <Tabs defaultActiveKey={1}>
                <TabPane tab="Mobiliario" key="1">
                    <RoomFurnishingsTab roomId={'fd'}/>
                </TabPane>
            </Tabs>
        </Row>
    );
}

export default FrontDeskDetails;